<div class="bg-gray-50 rounded-lg p-6 text-center">
  <div class="flex flex-col items-center">
    <h3 class="mb-2">DNS Managed Externally</h3>
    <p class="text-night-lighter max-w-lg">
      This domain's DNS is managed by an external provider. To make changes to DNS records, please visit your domain
      registrar or DNS provider's website.
    </p>
  </div>
</div>
